import { REGISTER } from "../../store/utils/routes";
import { AuthResponse } from "../../store/actions/accountInfo";
import {
  AUTH_FAILED,
  INVALID_USERNAME_ON_SIGNUP,
} from "../../store/models/exceptions";
import { makeBackendPostCallWithJsonResponse } from "../../store/utils/fetch";

export interface SignUpParams {
  username: string;
  password: string;
  email: string;
  anonymousId?: string;
  isEngineer?: boolean;
}

export const postSignUp = async (params: SignUpParams) => {
  const body = {
    username: params.username.toLowerCase().trim(),
    password: params.password,
    anonymous_id: params.anonymousId,
    email: params.email.toLowerCase().trim(),
  };
  return makeBackendPostCallWithJsonResponse<AuthResponse>(REGISTER, body).then(
    (res) => {
      if (res.success) {
        return res.resultJson;
      }
      if (res.resultJson.code === AUTH_FAILED) {
        res.resultJson.code = INVALID_USERNAME_ON_SIGNUP;
      }
      throw res.resultJson;
    },
  );
};
